import { graphql, useStaticQuery } from 'gatsby'

const useQuery = () => {
  const query = useStaticQuery(graphql`
    query {
      servicesImage: file(relativePath: { eq: "at-work/services.jpg" }) {
        ...largeFluidImage
      }
      teamImage: file(relativePath: { eq: "team/team-2.jpg" }) {
        ...largeFluidImage
      }
      jobsImage: file(relativePath: { eq: "agency-life/jobs-1.jpg" }) {
        ...largeFluidImage
      }
      casesImage: file(relativePath: { eq: "agency-life/standup/standup-2.jpg" }) {
        ...largeFluidImage
      }
    }
  `)

  return query
}

export default useQuery
